var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataTable"},_vm._l((_vm.indexes.length),function(i){return _c('DataBox',{key:i,ref:"dataBox",refInFor:true,attrs:{"profile":_vm.profile,"editMode":_vm.$parent.ownProfile,"dataListIndex":_vm.indexes[i - 1]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }